import React from 'react';

const getDocsUrl = () => {
  const explicit = process.env.REACT_APP_SUBSCRIPTION_API_URL;
  if (explicit) {
    return explicit.replace(/\/api\/?$/, '/api/docs');
  }

  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8011/api/docs';
  }

  return `${window.location.origin}/api/docs`;
};

const ApiDocsPage = () => {
  const docsUrl = getDocsUrl();

  return (
    <div className="container-fluid py-4">
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
        <div>
          <h4 className="fw-700 mb-1">API Documentation</h4>
          <div className="text-muted">Swagger docs for auth, integrations, and billing APIs.</div>
        </div>
        <a href={docsUrl} target="_blank" rel="noreferrer" className="btn btn-outline-primary">
          <i className="bi bi-box-arrow-up-right me-2"></i>
          Open in New Tab
        </a>
      </div>

      <div className="card border-0 shadow-sm overflow-hidden">
        <div className="card-body p-0">
          <iframe
            title="Subscription API Docs"
            src={docsUrl}
            style={{ width: '100%', minHeight: '78vh', border: 0 }}
          />
        </div>
      </div>
    </div>
  );
};

export default ApiDocsPage;
